module.exports = __webpack_public_path__ + "static/media/Goodnest_android_2.98350a52.jpg";